import { render, staticRenderFns } from "./DetalleNoticia.vue?vue&type=template&id=9b044876&scoped=true"
import script from "./DetalleNoticia.vue?vue&type=script&lang=js"
export * from "./DetalleNoticia.vue?vue&type=script&lang=js"
import style0 from "./DetalleNoticia.vue?vue&type=style&index=0&id=9b044876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b044876",
  null
  
)

export default component.exports